import styled from "styled-components";

interface IPaymentsOverviewProps {
  $isFromCheckout?: boolean;
}

export const PaymentsOverviewContainer = styled.section<IPaymentsOverviewProps>`
  padding: ${({ $isFromCheckout }) => ($isFromCheckout ? "32px 0px 0px" : "36px 24px")};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  min-height: 162px;
  gap: ${({ theme }) => theme.customTheme.pxToRem(24)};

  max-width: 375px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: 517px;
    padding: ${({ $isFromCheckout }) => ($isFromCheckout ? "32px 0px 0px" : "36px 0px")};
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    align-items: center;
    border-top: 1px solid
      ${({ theme, $isFromCheckout }) => ($isFromCheckout ? "none" : theme.customTheme.palette.grey.greyAC)};
    border-bottom: 1px solid
      ${({ theme, $isFromCheckout }) => ($isFromCheckout ? "none" : theme.customTheme.palette.grey.greyAC)};
    margin-top: ${({ $isFromCheckout }) => ($isFromCheckout ? "0" : "80px")};
    margin-bottom: ${({ $isFromCheckout }) => ($isFromCheckout ? "0" : "80px")};
    max-width: 684px;
    justify-content: ${({ $isFromCheckout }) => ($isFromCheckout ? "flex-start" : "space-between")};
    padding: ${({ $isFromCheckout }) => ($isFromCheckout ? "24px 0" : "80px 0")};
  }
`;

export const HeadingContainer = styled.div<IPaymentsOverviewProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: ${({ $isFromCheckout }) => ($isFromCheckout ? "100%" : "449px")};
    align-items: flex-start;
  }
`;

export const Title = styled.span<IPaymentsOverviewProps>`
  font-family: ThemeFontBold;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
  font-weight: 700;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(28) : theme.customTheme.pxToRem(20)};
    line-height: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(36) : theme.customTheme.pxToRem(24)};
  }
`;

export const Price = styled.span<IPaymentsOverviewProps>`
  font-family: ThemeFontBold;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
  font-weight: 700;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(28) : theme.customTheme.pxToRem(20)};
    line-height: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(36) : theme.customTheme.pxToRem(24)};
  }
`;

export const ItemsList = styled.div<IPaymentsOverviewProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${({ theme }) => theme.customTheme.pxToRem(24)};

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: ${({ $isFromCheckout }) => ($isFromCheckout ? "100%" : "449px")};
  }
`;

export const ItemContainer = styled.div`
  width: 100%;
  gap: ${({ theme }) => theme.customTheme.pxToRem(4)};
  display: flex;
  flex-direction: column;
`;

export const ItemTitle = styled.span<IPaymentsOverviewProps>`
  font-family: ThemeFontBold;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(14)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(18)};
  font-weight: 700;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(24) : theme.customTheme.pxToRem(16)};
    line-height: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(32) : theme.customTheme.pxToRem(20)};
  }
`;

export const ItemContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ItemDescription = styled.span<IPaymentsOverviewProps>`
  font-family: ThemeFontRegular;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(14)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  font-weight: 400;
  margin-right: 8px;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(24) : theme.customTheme.pxToRem(16)};
    line-height: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(32) : theme.customTheme.pxToRem(20)};
  }
`;

export const ItemPrice = styled.span<IPaymentsOverviewProps>`
  font-family: ThemeFontBold;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(14)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(18)};
  font-weight: 700;
  flex-shrink: 0;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(24) : theme.customTheme.pxToRem(16)};
    line-height: ${({ theme, $isFromCheckout }) =>
      $isFromCheckout ? theme.customTheme.pxToRem(32) : theme.customTheme.pxToRem(20)};
  }
`;

export const ItemDivider = styled.hr`
  width: 100%;
  margin-top: -8px;
`;
